// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Z3Ix","box":"WorkspacesBox_box__2QLrw","node":"WorkspacesBox_node__1fa71"};